"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var query_exports = {};
__export(query_exports, {
  LabelsQuery: () => LabelsQuery
});
module.exports = __toCommonJS(query_exports);
var import_communication_sdk_types = require("@hcengineering/communication-sdk-types");
var import_result = require("../result");
function getId(label) {
  return `${label.labelId}:${label.cardId}:${label.account}`;
}
__name(getId, "getId");
class LabelsQuery {
  constructor(client, hulylake, id, params, options, callback, initialResult) {
    this.client = client;
    this.hulylake = hulylake;
    this.id = id;
    this.params = params;
    this.options = options;
    this.callback = callback;
    if (initialResult !== void 0) {
      this.result = initialResult;
      void this.notify();
    } else {
      this.result = this.initResult();
      void this.result.then(() => {
        void this.notify();
      });
    }
  }
  static {
    __name(this, "LabelsQuery");
  }
  result;
  isCardRemoved = false;
  async onEvent(event) {
    if (this.isCardRemoved) return;
    switch (event.type) {
      case import_communication_sdk_types.LabelEventType.CreateLabel:
        await this.onLabelCreated(event);
        break;
      case import_communication_sdk_types.LabelEventType.RemoveLabel:
        await this.onLabelRemoved(event);
        break;
      case import_communication_sdk_types.CardEventType.UpdateCardType:
        await this.onCardTypeUpdated(event);
        break;
      case import_communication_sdk_types.CardEventType.RemoveCard:
        await this.onCardRemoved(event);
        break;
    }
  }
  async onLabelCreated(event) {
    if (this.result instanceof Promise) this.result = await this.result;
    if (this.params.limit != null && this.result.length >= this.params.limit) return;
    const label = {
      labelId: event.labelId,
      cardId: event.cardId,
      cardType: event.cardType,
      account: event.account,
      created: event.date ?? /* @__PURE__ */ new Date()
    };
    const match = this.match(label);
    if (!match) return;
    const existing = this.result.get(getId(label));
    if (existing != null) return;
    this.result.push(label);
    void this.notify();
  }
  async onLabelRemoved(event) {
    if (this.result instanceof Promise) this.result = await this.result;
    const existing = this.result.getResult().find((it) => it.account === event.account && it.cardId === event.cardId && it.labelId === event.labelId);
    if (existing === void 0) return;
    const prevLength = this.result.length;
    this.result.delete(getId(existing));
    if (this.params.limit != null && this.result.length < this.params.limit && prevLength >= this.params.limit) {
      const labels = await this.find(this.params);
      this.result = new import_result.QueryResult(labels, getId);
    }
    void this.notify();
  }
  async onCardTypeUpdated(event) {
    if (this.result instanceof Promise) this.result = await this.result;
    const result = this.result.getResult();
    const currentLength = this.result.length;
    let updated = false;
    if (this.params.cardType != null) {
      const cardTypes = Array.isArray(this.params.cardType) ? this.params.cardType : [this.params.cardType];
      if (cardTypes.includes(event.cardType)) {
        const labels = await this.find(this.params);
        this.result = new import_result.QueryResult(labels, getId);
        void this.notify();
        return;
      }
    }
    for (const label of result) {
      if (label.cardId === event.cardId) {
        const updatedLabel = { ...label, cardType: event.cardType };
        const matched = this.match(updatedLabel);
        if (matched) {
          this.result.update(updatedLabel);
        } else {
          this.result.delete(getId(label));
        }
        updated = true;
      }
    }
    if (updated) {
      const newLength = this.result.length;
      if (this.params.limit != null && newLength < currentLength && newLength >= this.params.limit) {
        const labels = await this.find(this.params);
        this.result = new import_result.QueryResult(labels, getId);
      }
      void this.notify();
    }
  }
  async onCardRemoved(event) {
    if (this.result instanceof Promise) this.result = await this.result;
    if (this.params.cardId === event.cardId) {
      this.isCardRemoved = true;
      this.result.deleteAll();
      void this.notify();
      return;
    }
    const result = this.result.getResult();
    const prevLength = this.result.length;
    let deleted = false;
    for (const label of result) {
      if (label.cardId === event.cardId) {
        this.result.delete(label.labelId);
        deleted = true;
      }
    }
    if (deleted) {
      if (this.params.limit != null && this.result.length < this.params.limit && prevLength >= this.params.limit) {
        const labels = await this.find(this.params);
        this.result = new import_result.QueryResult(labels, getId);
      }
      void this.notify();
    }
  }
  async onRequest(event, promise) {
  }
  async initResult() {
    try {
      const res = await this.find(this.params);
      return new import_result.QueryResult(res, getId);
    } catch (error) {
      console.error("Failed to initialize query:", error);
      return new import_result.QueryResult([], getId);
    }
  }
  async unsubscribe() {
  }
  removeCallback() {
    this.callback = () => {
    };
  }
  setCallback(callback) {
    this.callback = callback;
    void this.notify();
  }
  copyResult() {
    if (this.result instanceof Promise) {
      return void 0;
    }
    return this.result.copy();
  }
  async find(params) {
    if (this.isCardRemoved) return [];
    return await this.client.findLabels(params, this.id);
  }
  async notify() {
    if (this.callback == null) return;
    if (this.result instanceof Promise) this.result = await this.result;
    const result = this.result.getResult();
    this.callback(result);
  }
  match(label) {
    if (this.params.account != null && this.params.account !== label.account) {
      return false;
    }
    if (this.params.cardId != null && this.params.cardId !== label.cardId) {
      return false;
    }
    if (this.params.labelId != null) {
      const labels = Array.isArray(this.params.labelId) ? this.params.labelId : [this.params.labelId];
      if (!labels.includes(label.labelId)) {
        return false;
      }
    }
    if (this.params.cardType != null) {
      const types = Array.isArray(this.params.cardType) ? this.params.cardType : [this.params.cardType];
      if (!types.includes(label.cardType)) {
        return false;
      }
    }
    return true;
  }
  async refresh() {
    this.result = new import_result.QueryResult([], getId);
    this.result = this.initResult();
    void this.result.then(() => {
      void this.notify();
    });
  }
}
//# sourceMappingURL=query.js.map
